import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortAsc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 41,
	height: 37,
	viewBox: "0 0 41 37",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C1.65 0 3.3 0 5 0 C5 9.24 5 18.48 5 28 C6.65 28 8.3 28 10 28 C8.4169423 32.2742558 5.49431596 34.26531794 2 37 C0.66368764 35.6905332 -0.66897925 34.37734515 -2 33.0625 C-2.7425 32.33160156 -3.485 31.60070312 -4.25 30.84765625 C-6 29 -6 29 -6 28 C-4.02 28 -2.04 28 0 28 C0 18.76 0 9.52 0 0 Z ",
			fill: "currentColor",
			transform: "translate(31,0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C6.93 0 13.86 0 21 0 C21 1.65 21 3.3 21 5 C14.07 5 7.14 5 0 5 C0 3.35 0 1.7 0 0 Z ",
			fill: "currentColor",
			transform: "translate(1,28)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C4.95 0 9.9 0 15 0 C15 1.65 15 3.3 15 5 C10.05 5 5.1 5 0 5 C0 3.35 0 1.7 0 0 Z ",
			fill: "currentColor",
			transform: "translate(1,16)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C2.97 0 5.94 0 9 0 C9 1.65 9 3.3 9 5 C6.03 5 3.06 5 0 5 C0 3.35 0 1.7 0 0 Z ",
			fill: "currentColor",
			transform: "translate(1,4)"
		})
	]
});
export default SvgSortAsc;
